/*
 * Layout for the learner results region, where the sortable list and controls
 * are located
 */

define([
  "jquery",
  "marionette",
  "modules/learner/learnerResults/template/learnerResultsTemplate.html",
], function ($, Marionette, LearnerResultsTemplate) {
  "use strict";

  const LearnerResultsView = {};

  LearnerResultsView.learnerResultsLayout = Marionette.Layout.extend({
    template: LearnerResultsTemplate,
    events: {
      "click #changeTranscriptStatus": function () {
        //use event instead of trigger to avoid blocking the propogation of this event
        //if we are opening the change status menu, trigger the event and generate menu listing
        if (!this.$el.find(".btn-group").hasClass("open")) {
          //since the menu will show up even if we don't want it to, hide it until we are sure we want to show the menu
          this.$el.find("#changeTranscriptStatusMenu").addClass("hidden");
          this.trigger("open:transcript:status:menu");
        }
      },
    },
    regions: {
      list: "#learnerResultsList",
    },
    clearError: function () {
      this.$el.find("#controlsError").html("");
    },
    controlsError: function (errorMessage) {
      this.$el
        .find("#controlsError")
        .html('<h5 class="error-message">' + errorMessage + "</h5>")
        .hide()
        .fadeIn();
    },
    setResultsCount: function (count) {
      //set the number of search results returned
      this.$el.find("#learnerResultsCount").text("(" + count + ")");
    },
    setStatusMenu: function (statuses, transcripts) {
      this.$el.find("#changeTranscriptStatusMenu").html("");
      statuses.each(function (status) {
        const htmlItem =
          "<li id='" + status.get("id") + "'><a href='#'>" + status.get("value") + "</a></li>";
        this.$el.find("#changeTranscriptStatusMenu").append(htmlItem);
        const _view = this;
        this.$el.find("#changeTranscriptStatusMenu #" + status.get("id")).one("click", function () {
          //close menu
          $(".btn-group").removeClass("open");
          //trigger changing the statuses
          _view.trigger("change:transcript:status", transcripts, status.get("id"));
          return false;
        });
      }, this);
      this.$el.find("#changeTranscriptStatusMenu").removeClass("hidden"); //finally, show the menu now that we have items to show
    },
    triggers: {
      "click #deleteTranscripts": "delete:transcripts",
      "click #showTopics": "show:topics:page",
      "click #learnerDownload": "download:results",
    },
  });

  return LearnerResultsView;
});
